import { Detector } from "../detector/detector";
import { config as devToolsConfig } from "./config";
import { clearLog } from "./log";
import { clearDevToolOpenState } from "./open-state";
import { IS, hackAlert, onPageShowHide } from "./util";
import DebugLib from '../detector/sub-detector/debug-lib';

let interval: any = 0, timer: any = 0;
const calls: Detector[] = [];
let time = 0;

export function initInterval() {
  let _pause = false;
  const pause = () => {_pause = true;};
  const goon = () => {_pause = false;};
  hackAlert(pause, goon);       // 防止 alert 等方法觸發了 debug 延遲計算
  onPageShowHide(goon, pause);  // 防止切後台觸發了debug 延遲計算

  interval = window.setInterval(() => {
    for (const detector of calls) {
      clearDevToolOpenState(detector.type);
      detector.detect(time++);
    };
    clearLog();
  }, devToolsConfig.interval);

  // stopIntervalTime 之後判斷 如果不是 pc 去掉定時器 interval，為了優化移動端的性能
  // 如果控制面板被打開了該定時器 timer 會被清除
  timer = setTimeout(() => {
    if (!IS.pc && !DebugLib.isUsing()) {
      clearDetectorDetectInterval();
    }
  }, devToolsConfig.stopIntervalTime);
}

export function registInterval(detector: Detector) {
  calls.push(detector);
}

export function clearDetectorDetectInterval() {
  window.clearInterval(interval);
}

export function clearDetectorDetectTimeout() {
  window.clearTimeout(timer);
}